module.exports = __webpack_public_path__ + "static/media/3.ca7e41e5.png";